import UserRoleAPI from '../../api/user_roles';

const state = {
    userRole: {
        //
    },
    userRoles: []
};
 
const getters = {
    getUserRole(state) {
        return state.user;
    },
    getUserRoles(state) {
        return state.userRoles;
    }
};

const actions = { 
    async getUserRole({commit}, id) {
        let userRole = await UserRoleAPI.find(id);
        commit('setUserRole', userRole);
    },

    async getUserRoles({commit}) {
        let userRoles = await UserRoleAPI.all();
        commit('setUserRoles', userRoles);
    },
};

const mutations = {
    setUserRole(state, userRole = {})
    {   
        state.userRole = userRole;
    },
    setUserRoles(state, userRoles = [])
    {
        state.userRoles = userRoles;
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
